/*
|--------------------------------------------------------------------------
| State
|--------------------------------------------------------------------------
*/

const state = {
    patientDetailsValid: false,

    injuryDetailsValid: false,

    paymentDetailsValid: false,

    patientDetails: {
        title: null,
        firstName: '',
        lastName: '',
        phone: '',
        email: '',
        marketing: false,
        address1: '',
        address2: '',
        city: '',
        postcode: '',
    },

    injuryDetails: {
        newOrExisting: 'new',
        bodyPart: null,
        additionalInfo: '',
        dateOfBirth: '',
        gender: null,
        genderOther: '',
        specificAccessNeeds: false,
        specificAccessNeedsNotes: '',
        acceptTerms: false,
    },

    paymentDetails: {
        altBillingAddress: false,
        address1: '',
        address2: '',
        city: '',
        postcode: '',
    },
};

/*
|--------------------------------------------------------------------------
| Actions
|--------------------------------------------------------------------------
*/

const actions = {
    setPatientDetailsValid({ commit }) {
        commit('setPatientDetailsValid', true);
    },

    setPatientDetailsInvalid({ commit }) {
        commit('setPatientDetailsValid', false);
    },

    setInjuryDetailsValid({ commit }) {
        commit('setInjuryDetailsValid', true);
    },

    setInjuryDetailsInvalid({ commit }) {
        commit('setInjuryDetailsValid', false);
    },

    setPaymentDetailsValid({ commit }) {
        commit('setPaymentDetailsValid', true);
    },

    setPaymentDetailsInvalid({ commit }) {
        commit('setPaymentDetailsValid', false);
    },

    setPatientDetails({ commit }, data) {
        commit('setPatientDetails', data);
    },

    setInjuryDetails({ commit }, data) {
        commit('setInjuryDetails', data);
    },

    setPaymentDetails({ commit }, data) {
        commit('setPaymentDetails', data);
    },
};

/*
|--------------------------------------------------------------------------
| Mutations
|--------------------------------------------------------------------------
*/

const mutations = {
    setPatientDetailsValid(state, valid) {
        state.patientDetailsValid = valid;
    },

    setInjuryDetailsValid(state, valid) {
        state.injuryDetailsValid = valid;
    },

    setPaymentDetailsValid(state, valid) {
        state.paymentDetailsValid = valid;
    },

    setPatientDetails(state, data) {
        state.patientDetails = data;
    },

    setInjuryDetails(state, data) {
        state.injuryDetails = data;
    },

    setPaymentDetails(state, data) {
        state.paymentDetails = data;
    },
};

/*
|--------------------------------------------------------------------------
| Export
|--------------------------------------------------------------------------
*/

export const checkout = {
    namespaced: true,
    actions,
    mutations,
    state,
};
